// @flow

import type { JsEnv, Visitor } from '../../type'

import * as React from 'react'
import { Map } from 'immutable'
import { compose } from 'redux'
import { EasyJsEnv } from 'projects/easy/public/easyJsEnv'
import { withProps } from './index'
import { getPageInfo } from '../../pageInfo'
import dataHandler from './dataHandler'
import formValues from './formValues'
import visibility from './visibility'
import rootData from './rootData'
import afterComputeData from './afterComputeData'
import customStyle from '../hoc/customStyle'
import visitorInfo from './visitorInfo'

function getRootData (rootDataMap: Map<*, *>) {
  if (rootDataMap && typeof rootDataMap.toJS === 'function') {
    return rootDataMap.toJS()
  }
}

type Props = {
  compId: string,
  formValues?: {},
  setFormValues: ({ [key: string]: any }) => void,
  dataCode: ?string,
  compInputData: any,
  rootData: Map<*, *>, // Immutable Map,
  customProps: any,
  visitor: Visitor,
  // EasyCompComponent
  callActions: (eventName: string, compInputData: any, jsEnv: JsEnv) => void
};

type Opts = {
  includeData?: boolean,
  includeVisible?: boolean,
  annotation?: string
};

// 保存最新的 env 信息， 防止属性更新后无法获取最新的 env 信息
const jsEnvMap: { [string]: EasyJsEnv } = {}

export default function (opts: Opts = {}) {
  const { includeData = false, includeVisible = true, annotation } = opts
  const hocs = [
    rootData,
    visitorInfo,
    formValues, // formValues
    includeData && dataHandler, // compInputData, dataCode
    withProps((props: Props) => {
      const {
        formValues,
        compInputData,
        rootData,
        dataCode,
        customProps = {},
        callActions,
        visitor,
        compId
      } = props
      let envKey = compId
      if (customProps.$indexes) {
        envKey += customProps.$indexes.join('')
      }
      const baseContext = {
        ...customProps,
        $form: formValues,
        $root: getRootData(rootData),
        $query: getPageInfo().query,
        $offsetTime: getPageInfo().offsetTime,
        $visitor: visitor,
        $href: window.location.href,
        $encodeHref: window.encodeURIComponent(window.location.href)
      }

      jsEnvMap[envKey] = new EasyJsEnv(baseContext, compInputData)
      if (dataCode) {
        jsEnvMap[envKey].setDataCode(dataCode)
      }
      const jsEnv: JsEnv = {
        getString (tpl: string): string {
          return jsEnvMap[envKey].getString(tpl)
        },
        runCode (code: string): any {
          return jsEnvMap[envKey].runCode(code)
        },
        getStringWithAdditionCtx (tpl: string, contextAdded: Object): string {
          return jsEnvMap[envKey].getStringWithAdditionCtx(tpl, contextAdded)
        },
        runCodeWithAdditionalCtx (code: string, contextAdded: any): any {
          if (
            contextAdded != null &&
            (typeof contextAdded !== 'object' || Array.isArray(contextAdded))
          ) {
            contextAdded = { value: contextAdded }
          }
          return jsEnvMap[envKey].runCodeWithAdditionalCtx(code, contextAdded)
        },
        getContext () {
          return jsEnvMap[envKey].getContext()
        },
        getComponentData () {
          return jsEnvMap[envKey].getComponentData()
        }
      }
      return {
        jsEnv,
        callActions (eventName: string, dynamicData: any) {
          callActions(eventName, dynamicData, jsEnv)
        }
      }
    }),
    afterComputeData(includeData, annotation),
    includeVisible && visibility,
    customStyle
  ]
  return function (WrappedComponent: React.ComponentType<*>) {
    // $FlowFixMe
    return compose(...hocs.filter(hoc => hoc))(WrappedComponent)
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/hoc/computeData.js